import { useQuery } from "@tanstack/react-query";
import { abroadReviewApi } from "../../api/abroadLoans";
import { problemOf } from "../../api/scholarships";
import { ABROAD_KEY } from "./model";

// Review queries sit under ABROAD_KEY too, so a call's change refreshes them
export const REVIEW_KEY = [...ABROAD_KEY, "review"];
export const committeeKey = (callId) => [...REVIEW_KEY, "committee", callId];
export const scoresKey = (callId) => [...REVIEW_KEY, "scores", callId];
export const scoredApplicationKey = (id) => [...REVIEW_KEY, "application", id];
export const awardListKey = (callId) => [...REVIEW_KEY, "award-list", callId];

export const reviewApplicantsPath = "/loans/abroad/applicants";
export const callReviewPath = (callId) => `${reviewApplicantsPath}/${callId}`;

// Where a submitted application stands (ApplicationState), as staff see it
export const APPLICATION_STATES = [
  { value: "SUBMITTED", label: "Submitted", color: "blue" },
  { value: "WITH_DG", label: "With the DG", color: "brand" },
  { value: "WITH_MINISTER", label: "With the Minister", color: "brand" },
  { value: "RETURNED_TO_HEC", label: "Returned to HEC", color: "yellow" },
  { value: "APPROVED", label: "Approved", color: "green" },
  { value: "RESERVE", label: "Reserve", color: "yellow" },
  { value: "NOT_AWARDED", label: "Not awarded", color: "gray" },
  { value: "REJECTED", label: "Rejected", color: "red" },
];
export const applicationStateOf = (value) => APPLICATION_STATES.find((s) => s.value === value) ?? { value, label: value ?? "—", color: "gray" };

// An award list entry or a decision row as the approved funding dialog reads it
export const fundingEntryOf = (row) => row && { applicant: { firstName: row.applicantName }, requestedFunding: row.requested, approvedFunding: row.approvedAmounts };

export const useCommittee = (callId) =>
  useQuery({
    queryKey: committeeKey(callId),
    enabled: Boolean(callId),
    queryFn: async () => (await abroadReviewApi.committee(callId)).data,
  });

export const useCallScores = (callId) =>
  useQuery({
    queryKey: scoresKey(callId),
    enabled: Boolean(callId),
    queryFn: async () => (await abroadReviewApi.scores(callId)).data,
  });

export const useScoredApplication = (id) =>
  useQuery({
    queryKey: scoredApplicationKey(id),
    enabled: Boolean(id),
    queryFn: async () => (await abroadReviewApi.application(id)).data,
  });

// The call's award list; a 404 means none has been made yet
export const useAwardList = (callId) =>
  useQuery({
    queryKey: awardListKey(callId),
    retry: (count, err) => problemOf(err)?.status !== 404 && count < 2,
    queryFn: async () => (await abroadReviewApi.awardList(callId)).data,
  });
